export default __webpack_public_path__ + "static/media/img-0375-ovato-nation-premium-face.1ea07be9.png";